var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreaThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68.738991mm",
    height: "68.354324mm",
    viewBox: "0 0 68.738991 68.354324",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-10.439759,-182.0868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2433",
    transform: "translate(-110.82078,53.128248)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59194b",
      fillOpacity: 1,
      strokeWidth: 0.499999,
      paintOrder: "stroke fill markers"
    },
    d: "m 149.39843,128.95855 -22.38963,13.59936 -5.74826,23.19924 10.82906,24.74797 31.47351,6.80775 24.44724,-16.86899 1.98918,-27.32198 -14.72361,-20.66155 z",
    id: "path236-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1247",
    style: {
      fill: "#fdfdfd",
      fillOpacity: 1,
      strokeWidth: 0.514532,
      paintOrder: "stroke fill markers"
    },
    d: "m 148.31724,143.3755 -0.2155,2.37092 16.16026,0.93844 -0.74259,-2.58795 -5.32126,-0.9152 -4.79134,-0.21992 z m -11.14764,2.24586 -0.46848,20.47152 0.58991,4.60912 38.17442,-1.53117 -0.47742,-16.95404 -0.59332,-4.04158 z m 1.12396,1.40767 5.04827,0.45268 -4.54908,0.23771 -0.40979,3.93568 z m 34.93947,1.81229 0.0894,3.23339 -0.54622,-2.52439 -2.61225,-0.67283 z m -11.02569,2.80086 5.54023,5.21829 1.65623,1.59938 1.03973,-1.58336 0.29456,3.66179 -3.74758,-0.32556 1.45935,-1.02681 -6.33243,-5.07773 -5.0767,7.16442 -5.31027,-2.00298 -8.6558,7.65122 -2.3182,-0.18656 1.10949,-2.51147 9.31261,-7.46879 5.48649,2.12751 z m 11.77189,13.47308 0.20206,3.31556 -4.18217,0.10801 3.62665,-0.56586 z m -35.70324,1.15549 0.71675,3.30574 3.78271,0.3638 -4.50773,0.0904 z m 27.79365,4.44675 -3.5171,0.14056 3.76205,12.36876 1.54822,1.16892 2.34921,-0.59015 z m -16.58658,0.54932 -3.37758,0.0233 -2.65513,12.94133 1.73219,0.68368 1.36943,-0.66921 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaThree);
export default __webpack_public_path__ + "static/media/Area_three.21155719447985cdf6748d3148600da7.svg";
export { ForwardRef as ReactComponent };